
import { realisationForVehicle } from '@/utils/realisationShowcase'
import { REALISATION_ROUTE_NAME } from '@/utils/realisationUrls'

export default {
  name: 'VehicleHero',
  props: {
    vehicle: { type: Object, required: true },
    title: { type: String, required: true },
    averageRating: { type: Number, default: 0 },
    reviewsCount: { type: Number, default: 0 },
    shareTitle: { type: String, default: '' },
    shareDescription: { type: String, default: '' },
    shareImage: { type: String, default: null },
    latestReview: { type: Object, default: null },
  },
  data() {
    return {
      introExpanded: false,
    }
  },
  computed: {
    workshopRealisation() {
      const id = realisationForVehicle(this.vehicle.id)
      return id
        ? this.localePath({
            name: REALISATION_ROUTE_NAME,
            params: { slug: String(id) },
          })
        : null
    },
    commercialIntroKey() {
      const keys = {
        car: 'components.vehicleHero.commercialIntroCar',
        motorcycle: 'components.vehicleHero.commercialIntroMotorcycle',
        truck: 'components.vehicleHero.commercialIntroTruck',
        tractor: 'components.vehicleHero.commercialIntroTractor',
      }
      return (
        keys[this.vehicle.vehicle_type?.identifier] ||
        'components.vehicleHero.commercialIntroDefault'
      )
    },
    commercialIntroCount() {
      return Math.floor(this.vehicle.products_count / 10) * 10
    },
    brandName() {
      return this.vehicle.brand?.name || ''
    },
    brandLink() {
      if (!this.vehicle.brand?.slug) return null
      return this.localePath({
        name: 'marques-vehicules-slug',
        params: { slug: this.vehicle.brand.slug },
      })
    },
    latestReviewAuthor() {
      const review = this.latestReview
      return (
        review?.user?.fullname_anonymous ||
        review?.user_fullname ||
        review?.user_firstname ||
        ''
      )
    },
    latestReviewExcerpt() {
      const message = (this.latestReview?.message || '')
        .replace(/\s+/g, ' ')
        .trim()
      if (!message) return ''
      return message.length > 90 ? `${message.slice(0, 90).trim()}…` : message
    },
    yearsLabel() {
      const from = this.vehicle.year_from
      const to = this.vehicle.year_to || this.$t('components.vehicleHero.today')
      return `${from} - ${to}`
    },
    imageAlt() {
      return [this.vehicle.brand?.name, this.vehicle.name]
        .filter(Boolean)
        .join(' ')
    },
    heroImage() {
      return this.vehicle.image || this.vehicle.brand?.image || null
    },
    vehicleImageSrc() {
      const image = this.heroImage
      if (!image) return null
      return this.$cropUrl(image, 252, '_', image.extension, 86)
    },
    vehicleImageSrcset() {
      const image = this.heroImage
      if (!image) return null
      return [
        `${this.$cropUrl(image, 126, '_', image.extension, 86)} 1x`,
        `${this.$cropUrl(image, 252, '_', image.extension, 86)} 2x`,
      ].join(', ')
    },
    brandLogoSrc() {
      const image = this.vehicle.brand?.image
      if (!image) return null
      return this.$cropUrl(image, 80, 80, image.extension, 86)
    },
    brandLogoSrcset() {
      const image = this.vehicle.brand?.image
      if (!image) return null
      return [
        `${this.$cropUrl(image, 40, 40, image.extension, 86)} 1x`,
        `${this.$cropUrl(image, 80, 80, image.extension, 86)} 2x`,
        `${this.$cropUrl(image, 120, 120, image.extension, 86)} 3x`,
      ].join(', ')
    },
  },
}
